import { QuizQuestion } from "../../shared/types";
import {
  TrendingUp,
  Campaign,
  HeadsetMic,
  Analytics,
  Person,
  Groups,
  Business,
  LocationCity,
  AttachMoney,
  CreditCard,
  Diamond,
  TrendingDown,
  Email,
  Facebook,
  ShoppingCart,
  Assignment,
  PhoneAndroid,
  Computer,
  Build,
  HelpOutline,
  MailOutline,
  Phone,
  Chat,
  MenuBook,
  Settings,
  Handshake,
  NoCell,
} from "@mui/icons-material";

export const crmQuestions: QuizQuestion[] = [
  {
    question: "What type of CRM features are you most interested in?",
    options: [
      { text: "Sales Automation", icon: TrendingUp },
      { text: "Marketing Automation", icon: Campaign },
      { text: "Customer Support", icon: HeadsetMic },
      { text: "Analytics and Reporting", icon: Analytics },
    ],
  },
  {
    question: "How many users will be using the CRM system?",
    options: [
      { text: "1-5", icon: Person },
      { text: "6-20", icon: Groups },
      { text: "21-50", icon: Business },
      { text: "50+", icon: LocationCity },
    ],
  },
  {
    question: "What is your primary goal for using a CRM?",
    options: [
      { text: "Increase Sales", icon: TrendingUp },
      { text: "Improve Customer Relationships", icon: Handshake },
      { text: "Streamline Operations", icon: Settings },
      { text: "Enhance Marketing Efforts", icon: Campaign },
    ],
  },
  {
    question: "Which integrations are important for your CRM?",
    options: [
      { text: "Email Marketing Tools", icon: Email },
      { text: "Social Media Platforms", icon: Facebook },
      { text: "E-commerce Solutions", icon: ShoppingCart },
      { text: "Project Management Tools", icon: Assignment },
    ],
  },
  {
    question: "What is your budget range for a CRM solution?",
    options: [
      { text: "$0 - $100/month", icon: AttachMoney },
      { text: "$100 - $200/month", icon: CreditCard },
      { text: "$201 - $500/month", icon: TrendingUp },
      { text: "$500+/month", icon: Diamond },
    ],
  },
  {
    question: "How important is mobile access to your CRM?",
    options: [
      { text: "Very Important", icon: PhoneAndroid },
      { text: "Somewhat Important", icon: Computer },
      { text: "Not Important", icon: TrendingDown },
      { text: "Not Sure", icon: HelpOutline },
    ],
  },
  {
    question: "Do you require customization options in your CRM?",
    options: [
      { text: "Yes", icon: Build },
      { text: "I don't know", icon: HelpOutline },
      { text: "No", icon: NoCell },
      { text: "You can decide for me", icon: Handshake },
    ],
  },
  {
    question: "How do you prefer to receive support?",
    options: [
      { text: "Email", icon: MailOutline },
      { text: "Phone", icon: Phone },
      { text: "Live Chat", icon: Chat },
      { text: "Help Articles", icon: MenuBook },
    ],
  },
];